import { Checkbox, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { ExcludedSecurityObj } from "../../../redux-store/types/onBoarding";
import CustomTable from "../../investorOverview/common/customTable";
import { PaginationObj, TableHeaderData } from "../../investorOverview/types";

const headerData: TableHeaderData[] = [
    {
        id: 'securityName',
        label: 'Security Name',
        align: 'left',
        isSortable: false,
    },
    {
        id: 'isExcluded',
        label: 'Is Excluded?',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'exclusionReason',
        label: 'Reason for Exclusion',
        align: 'center',
        isSortable: false,
    }
]

interface DataTableProps {
    tableBodyData: Array<ExcludedSecurityObj & { isExcluded: boolean; }>;
    onExclusionChange: (securityId: string, checked: boolean) => void;
}

function DataTable({
    tableBodyData,
    onExclusionChange
}: DataTableProps): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {tableBodyData.map((obj, index) => (
                <TableRow
                    key={`${obj.security}-${index}`}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        '& td:first-of-type': {
                            paddingLeft: "15px",
                        }
                    }}
                >
                    <TableCell align="left">
                        <Typography
                            variant="body_500"
                            sx={{
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary,
                            }}
                        >
                            {obj?.securityName ?? "-"} {obj?.security ? "(" + obj?.security + ")" : ""}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Checkbox
                            checked={obj.isExcluded}
                            onChange={(e) => onExclusionChange(obj.security, e.target.checked)}
                            size="small"
                        />
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.primary,
                            }}
                        >
                            {obj.isExcluded ? (obj?.exclusionReason ?? "-") : "-"}
                        </Typography>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}

interface SecurityExclusionTableProps {
    isLoading: boolean;
    tableData: Array<ExcludedSecurityObj & { isExcluded: boolean; }>;
    tablePaginationObj: PaginationObj;
    handleTableRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleTablePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
    onExclusionChange: (securityId: string, checked: boolean) => void;
}

export default function SecurityExclusionTable({
    isLoading,
    tableData,
    tablePaginationObj,
    handleTableRowsPerPageChange,
    handleTablePageChange,
    onExclusionChange,
}: SecurityExclusionTableProps): JSX.Element {
    return (
        <CustomTable
            isLoading={isLoading}
            tableBody={
                <DataTable
                    tableBodyData={tableData}
                    onExclusionChange={onExclusionChange}
                />
            }
            tableData={tableData}
            tableHeaderData={headerData}
            tableHeadRowCustomStyles={{
                '& th:first-of-type': {
                    paddingLeft: "20px"
                }
            }}
            tableBodyCustomStyles={{
                '& tr:last-child td': {
                    border: 0
                }
            }}
            loadingRowsNum={7}
            tableDataCount={tablePaginationObj.totalRows}
            rowsPerPage={tablePaginationObj.rowsPerPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            handleRowsPerPageChange={handleTableRowsPerPageChange}
            handlePageChange={handleTablePageChange}
            currentPage={tablePaginationObj.currentPage}
        />
    )
}